import 'react-grid-layout/css/styles.css';

import { Responsive, WidthProvider } from 'react-grid-layout';

import { BREAKPOINT_WIDTHS_BY_NAME, COLS_BY_BREAKPOINT } from '@blockworks/platform/api/research/studio';
import { Bit } from '@blockworks/ui/factory';
import { cn } from '@blockworks/ui/system';

import { DashboardGridProvider, useDashboardGrid, useDashboardGridContext } from './context';
import { DashboardMode, DRAGGABLE_CANCEL, RESIZE_HANDLES, ROW_HEIGHT } from './dashboard-grid.model';
import { DashboardGridItem } from './grid-item';
import { compressData, decompressData, fetchPreloadedDashboardData } from './utils';
import { fetchPreloadedVisualizationData } from './utils/fetch-preloaded-visualization';

const ResponsiveGridLayout = WidthProvider(Responsive);

const DashboardGrid = () => {
    const {
        handleOnResizeOrDragStop,
        handleOnResizeStart,
        handleOnResize,
        resizingItem,
        resizingItemHeight,
        isEditable,
        breakpoint,
        handleOnWidthChange,
        layouts,
        styles,
    } = useDashboardGrid();

    return (
        <Bit.div w="full" h="max" mx="auto" style={styles}>
            <ResponsiveGridLayout
                className={cn('w-full h-full min-h-[350px] overflow-x-hidden blockworks-rgl')}
                breakpoints={BREAKPOINT_WIDTHS_BY_NAME}
                breakpoint={breakpoint}
                cols={COLS_BY_BREAKPOINT}
                rowHeight={ROW_HEIGHT}
                draggableCancel={DRAGGABLE_CANCEL}
                useCSSTransforms
                measureBeforeMount={false}
                resizeHandles={RESIZE_HANDLES}
                onWidthChange={handleOnWidthChange}
                layouts={layouts}
                onDragStop={handleOnResizeOrDragStop}
                onResize={handleOnResize}
                onResizeStart={handleOnResizeStart}
                onResizeStop={handleOnResizeOrDragStop}
                isResizable={isEditable}
                isDraggable={isEditable}
            >
                {layouts?.[breakpoint]?.map(item => (
                    <DashboardGridItem
                        key={item.i}
                        resizingItemHeight={resizingItemHeight}
                        item={item}
                        resizingItem={resizingItem}
                    />
                ))}
            </ResponsiveGridLayout>
        </Bit.div>
    );
};

DashboardGrid.Provider = DashboardGridProvider;
DashboardGrid.useContext = useDashboardGridContext;
DashboardGrid.Mode = DashboardMode;
DashboardGrid.fetchPreloadedData = fetchPreloadedDashboardData;
DashboardGrid.fetchPreloadedVisualizationData = fetchPreloadedVisualizationData;
DashboardGrid.compressData = compressData;
DashboardGrid.decompressData = decompressData;

export { DashboardGrid };
